import { render, staticRenderFns } from "./index_causas.vue?vue&type=template&id=9a91d2e4&scoped=true&"
import script from "./index_causas.vue?vue&type=script&lang=js&"
export * from "./index_causas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a91d2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a91d2e4')) {
      api.createRecord('9a91d2e4', component.options)
    } else {
      api.reload('9a91d2e4', component.options)
    }
    module.hot.accept("./index_causas.vue?vue&type=template&id=9a91d2e4&scoped=true&", function () {
      api.rerender('9a91d2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/causas/index_causas.vue"
export default component.exports